module.exports = __webpack_public_path__ + "img/Expo_Topic4.6bb523c0.png";